// extracted by mini-css-extract-plugin
module.exports = {"contentComponent":"LandingWizardBuilds_contentComponent__1WO04","contentWrapper":"LandingWizardBuilds_contentWrapper__2Y_Ij"};